import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addToWatchlist } from '../redux/actions/movieActions';
import { Link } from 'react-router-dom';
import { AiFillStar } from 'react-icons/ai';
import { RiBookmark3Fill } from 'react-icons/ri';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import fullDate from '../components/DateFunction';
import rating from '../components/RatingFunctiion';

const NewMoviesPages = () => {
    // const sideInfos = useSelector((state) => state.mainMovies.main);
    const [newMoviesPage, setNewMoviesPage] = useState([]);
    const [pageNo, setPageNo] = useState('1');
    
    const pageState = {
        pages: [
            {id: 1, className: 'page-button'},
            {id: 2, className: 'page-button'},
            {id: 3, className: 'page-button'},
            {id: 4, className: 'page-button'},
            {id: 5, className: 'page-button'}
        ]
    }

    const dispatch = useDispatch();

    const getNewMovieRequestPage = async (pageNo) => {
        const url = `https://api.themoviedb.org/3/movie/upcoming?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&page=${pageNo}`;
        const response = await fetch(url);
        const infoData = await response.json();
        setNewMoviesPage(infoData.results);
    }

    useEffect(() => {
        getNewMovieRequestPage(pageNo);
        window.scrollTo({top: 0, behavior: 'smooth'});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNo]);

    const handlePageChange = event => {
        event.preventDefault();
        setPageNo(event.target.value);
    } 

    return (
        <div className='new-and-feat-page'>
            {
                Object.keys(newMoviesPage).length === 0 ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <section className="featured-section">
                            <div className="featured-header">
                                <div className="featured-header-link">
                                    New Movies
                                </div>
                            </div>
                            <div className="featured-movies">
                                {
                                    newMoviesPage.map((info) => (
                                        <div className="featured-movie" key={info.id}>
                                            <div className="featured-movie-img-container">
                                                <RiBookmark3Fill className="featured-book-icon" onClick={() => dispatch(addToWatchlist(info))}/>
                                                <Link to={`/movie/${info.id}`}>
                                                    <img src={(`https://image.tmdb.org/t/p/original${info.poster_path}`)} alt={info.title} className="featured-movie-img" />
                                                </Link>
                                            </div>
                                            <div className="featured-movie-info">
                                                <div className="feature-title-container">
                                                    <h2 className="feature-title">{(info.title).length < 26 ? info.title : `${(info.title).substring(0, 26)}...`}</h2>
                                                    <span>{rating(info.vote_average)} <AiFillStar /></span>
                                                </div>
                                                <p className="release-date">Released: {fullDate(info.release_date)}</p>
                                                <div className="featured-movie-buttons">
                                                    {/* <Link to={`/movie/${info.id}`} className="featured-movie-button"><AiFillPlayCircle className="feature-play-icon" /> watch trailer</Link> */}
                                                    <Link to={`/movie/${info.id}`} className="featured-movie-button">more details</Link>
                                                </div>            
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </section>
                    </>
                )
            }
            <div className="page-buttons">
                <h3 className="page-header">page:</h3>
                <div className="page-buttons-container">
                    {
                        pageState.pages.map(page => (
                            <button className={parseInt(pageNo) === page.id ? `${page.className} active` : page.className} value={page.id} key={page.id} onClick={handlePageChange}>{page.id}</button>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default NewMoviesPages
